"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var io_ts_1 = require("io-ts");
exports.fromRefinement = function () { return function (carrier, prism, name) {
    if (name === void 0) { name = "Refinement<" + carrier.name + ">"; }
    return new io_ts_1.Type(name, function (u) { return carrier.is(u) && prism.getOption(u).isSome(); }, function (u, c) { return carrier.validate(u, c).chain(function (s) { return prism.getOption(s).foldL(function () { return io_ts_1.failure(s, c); }, io_ts_1.success); }); }, function (a) { return carrier.encode(a); });
}; };
//# sourceMappingURL=fromRefinement.js.map